import React, { FC, useEffect, useState } from "react"

import { HeartFilled, LoadingOutlined, ExportOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import Table, { ColumnsType } from "antd/es/table"

import { IAdsListPayload } from "../../../../types/ads"
import { adsApi } from "../../../api/endpoints/adsApi"
import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { showErrorNotification, showSuccessNotification } from "../../../utils/ui"
import MetroView from "../../ui/metro-view/MetroView"
// import EditModal from "../ads/EditModal"
import {
    SourceView,
    // StatusView
} from "../ads/ExtraComponents"

import "./FavoritePage.scss"

const FavoritePage: FC = () => {
    // const [ editOpen, setEditOpen ] = useState(false)
    // const [ editId, setEditId ] = useState(0)
    const [ isFetch, setIsFetch ] = useState(false)

    const { isLoading, isFetching, tableData, tableMetaData } = useTypedSelector((state) => state.favorite)
    const {
        favoriteFetchData,
        setFavoriteFetching,
    // favoriteSendCall
    } = useActions()

    const columns: ColumnsType<any> = [
        {
            title: "Дата",
            dataIndex: "date",
            key: "date",
            width: 130,
        },
        {
            title: "",
            dataIndex: "actions",
            key: "actions",
            width: 70,
            render: (_, record) => (
                <div className="actions-cell">
                    <Tooltip title="Удалить из избранного">
                        <Button
                            size="small"
                            type="primary"
                            icon={<HeartFilled />}
                            onClick={() => {
                                adsApi.deleteFavoritesAd(record.id)
                                    .then((response) => {
                                        if (response.status === 200) {
                                            showSuccessNotification("Объявление удалено из избранного")
                                            setIsFetch(true)
                                        }
                                    })
                                    .catch(() => {
                                        showErrorNotification("Ошибка при удалении из избранного, повторите попытку")
                                    })
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Открыть">
                        <a href={record.title?.link} target="_blank" rel="noopener noreferrer">
                            <Button size="small" icon={<ExportOutlined />} />
                        </a>
                    </Tooltip>
                </div>
            )
        },
        {
            title: "Заголовок",
            dataIndex: "title",
            key: "title",
            width: 350,
            ellipsis: true,
            render: (value) => <span className="title-text">{value?.name}</span>
        },
        {
            title: "Источник",
            dataIndex: "source",
            key: "source",
            width: 80,
            render: (value) => value && <SourceView source={value.name} />
        },
        {
            title: "Цена",
            dataIndex: "price",
            key: "price",
            width: 100,
            render: (value) => <span className="price-cell">{value}</span>
        },
        {
            title: "Адрес",
            dataIndex: "address",
            key: "address",
            width: 220,
            render: (value) => (
                <div className="address-cell">
                    <div className="address-name">{value?.name}</div>
                    {value?.metro?.name && (
                        <MetroView
                            title={value.metro.name}
                            color={`#${value.metro.color}`}
                        />
                    )}
                </div>
            )
        },
        {
            title: "Контакт",
            dataIndex: "phone",
            key: "phone",
            width: 110,
            render: (value) => <span className="phone-cell">{value}</span>
        },
    ]

    const fetchData = (paginationData = { page: 1, pageSize: 10, sorting: { name: "ASC" } }, withouLoading = false, onFinish?: () => void) => {
        const data: IAdsListPayload = {
            page: paginationData.page,
            pageSize: paginationData.pageSize,
            sorting: paginationData.sorting,
            filters: undefined,
        }

        favoriteFetchData(data, withouLoading, onFinish)
    }

    const bindTableRequest = (paginationData = { page: 1, pageSize: 10, sorting: { name: "ASC" } }) => {
        fetchData(paginationData)
    }

    useEffect(() => {
        bindTableRequest()
    }, [])

    useEffect(() => {
        if (isFetching) {
            bindTableRequest()
            setFavoriteFetching(false)
        }
    }, [ isFetching ])

    useEffect(() => {
        if (isFetch) {
            bindTableRequest({
                page: tableMetaData.currentPage,
                pageSize: tableMetaData.pageSize,
                sorting: { name: "ASC" }
            })
            setIsFetch(false)
        }
    }, [ isFetch ])

    return (
        <div className="page-content">
            <Table
                className="favorite-table"
                dataSource={tableData || []}
                columns={columns}
                rowKey="id"
                scroll={{ x: 900, y: 'calc(100vh - 280px)' }}
                rowClassName={(record) => record.removed ? "table__row_red" : ""}
                loading={{
                    spinning: isLoading,
                    indicator: <LoadingOutlined style={{ fontSize: 24 }} spin />
                }}
                pagination={{
                    position: ["bottomLeft"],
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "25", "50", "100"],
                    defaultCurrent: 1,
                    defaultPageSize: 10,
                    current: tableMetaData?.currentPage || 1,
                    total: tableMetaData.total,
                    onChange: (page, per_page) => bindTableRequest({
                        page: page,
                        pageSize: per_page,
                        sorting: { name: "ASC" }
                    }),
                    onShowSizeChange: (page, per_page) => bindTableRequest({
                        page: page,
                        pageSize: per_page,
                        sorting: { name: "ASC" }
                    }),
                    showTotal: (total, range) =>
                        `${range[0]}-${range[1]} из ${total} объявлений`,
                }}
                size="small"
            />
        </div>
    )
}

export default FavoritePage
